module.exports = __webpack_public_path__ + "media/assets/images/sign_up_other-b1362b71fa31946c321ff1353d71b6a8.jpg";